import React from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Container,
  Button,
  Stack,
  Divider,
  Card,
  CardContent,
  Link
} from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

import valueLove from "../../assets/images/iamprogrammes/inner-peaceimages/loveIcon.png";
import valueViolence from "../../assets/images/iamprogrammes/coinimages/valueViolence.png";
import valueHumble from "../../assets/images/iamprogrammes/inner-peaceimages/humilityIcon.png";
import valueTruth from "../../assets/images/iamprogrammes/inner-peaceimages/truthIcon.png";
import valueForgiving from "../../assets/images/iamprogrammes/inner-peaceimages/forgiveIcon.png";
import valueGratitude from "../../assets/images/iamprogrammes/inner-peaceimages/gratitudeIcon.png";
import valueGiving from "../../assets/images/iamprogrammes/inner-peaceimages/givingIcon.png";
import valuePatience from "../../assets/images/iamprogrammes/inner-peaceimages/patienceIcon.png";


const conclusions = [
  {
    // title: "Gratitude",
    description: ` Course access — online and hybrid delivery.`,
    // image: valueGratitude,
  },
  {
    // title: "Forgiveness",
    description: `Eligibility —  open to all, free for Youth under 18.`,
    // image: valueForgiving,
  },
  {
    // title: "Love",
    description: `Goal — cultivate values for inner and Global Peace.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: ` Global reach — <br></br> across every continent.`,
    // image: valueLove,
  }
];


const onlineTest = [
  {
    text: (
      <>
        Embed the 7 Human <br></br> Values in daily life.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Improve emotional <br></br> intelligence and resilience.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Strengthen leadership <br></br> and conflict resolution skills.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Promote equality, empathy <br></br> and collaboration.
      </>
    ),
    colorClass: "gradient-yellow",
  },
    {
    text: (
      <>
       Foster community <br></br> action for Peace.
      </>
    ),
    colorClass: "gradient-blue",
  },
   {
    text: (
      <>
       Expand intercultural <br></br> understanding.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
       Inspire lifelong commitment <br></br> to Justice, Love & Peace.
      </>
    ),
    colorClass: "gradient-blue",
  },
];

const coreValues = [
  {
    // title: "Gratitude",
    description: `Inner Peace Course - Live`,
    // image: valueGratitude,
  },
  {
    // title: "Forgiveness",
    description: `Women in Peace Course — Coming Soon`,
    // image: valueForgiving,
  },
  {
    // title: "Love",
    description: `Peace Leadership Course — Coming Soon`,
    // image: valueLove,
  }
];
const courseBenefits = [
  {
    // title: "Gratitude",
    description: ` Certificate of recognition.`,
    // image: valueGratitude,
  },
  {
    // title: "Forgiveness",
    description: ` Flexible online modules.`,
    // image: valueForgiving,
  },
  {
    // title: "Love",
    description: `Expert‑led sessions.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: `Downloadable resources.`,
    // image: valueLove,
  },
    {
    // title: "Love",
    description: ` Real‑life application tasks.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: `Peer‑to‑peer networking.`,
    // image: valueLove,
  },
     {
    // title: "Love",
    description: `Discussion forums.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: `Live Q&A events.`,
    // image: valueLove,
  },
  {
    // title: "Love",
    description: `Project showcase opportunities.`,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: <>
            Pathways to become an <i>I Am Peacekeeper </i>  Ambassador.


    </>,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: <>
           Listing on official <i>I Am Peacekeeper </i> websites.


    </>,
    // image: valueLove,
  },
   {
    // title: "Love",
    description: <>
          Access to alumni community and advanced courses.

    </>,
    // image: valueLove,
  },

];

// const courseBenefits = [
//   {
//     text: (
//       <>
//         Certificate of recognition.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//   {
//     text: (
//       <>
//         Flexible online modules.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//    {
//     text: (
//       <>
//       Expert‑led sessions.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//   {
//     text: (
//       <>
//        Downloadable resources.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//    {
//     text: (
//       <>
//        Real‑life application tasks.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//        Peer‑to‑peer networking.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//     {
//     text: (
//       <>
//       Discussion forums.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//       Live Q&A events.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//   {
//     text: (
//       <>
//       Project showcase opportunities.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//       Pathways to become an <i>I Am Peacekeeper </i>  Ambassador.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
//   {
//     text: (
//       <>
//       Listing on official <i>I Am Peacekeeper </i> websites.
//       </>
//     ),
//     colorClass: "gradient-blue",
//   },
//    {
//     text: (
//       <>
//       Access to alumni community and advanced courses.
//       </>
//     ),
//     colorClass: "gradient-yellow",
//   },
// ];

const circleCourses = [
  {
    text: (
      <>
        Enrol today.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Join a global community of learners.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Apply your learning to real‑world change.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Lead the movement for Justice, Love & Peace.
      </>
    ),
    colorClass: "gradient-yellow",
  }
];
const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const OnlineTestCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards  ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2">
      {text}
    </Typography>
  </Paper>
);

const sdgs = [
  {
    title: "SDG 4",
    description: (
      <>
        "Quality Education – <br></br> Infusing human values in <br></br> higher
        education
      </>
    ),

    icon: imgUrl.sdg4Icon,
  },
  {
    title: "SDG 16",
    description: (
      <>
        Peace, Justice & Strong <br></br> Institutions – Nurturing <br></br>{" "}
        conscious student leaders
      </>
    ),
    icon: imgUrl.sdg16Icon,
  },
  {
    title: "SDG 3",
    description: (
      <>
        Good Health & Well-being <br></br> – Emotional and mental <br></br>{" "}
        wellness via values <br></br> training
      </>
    ),
    icon: imgUrl.sdg3Icon,
  },
  {
    title: "SDG 5",
    description: (
      <>
        Gender Equality – <br></br> Promoting inclusion, <br></br> empathy, and
        respect
      </>
    ),
    icon: imgUrl.sdg5Icon,
  },
  {
    title: "SDG 10",
    description: (
      <>
        "Reduced Inequalities <br></br> – Building unity across <br></br>{" "}
        communities and cultures
      </>
    ),
    icon: imgUrl.sdg10Icon,
  },
  {
    title: "SDG 17",
    description: (
      <>
        Partnerships for the <br></br> Goals – International <br></br>{" "}
        collaboration for peace
      </>
    ),
  },
];

const Courses = () => {
  return (
    <>
      {/* InnerPeace Hero Background Section */}
      <Box
        className="programInnerPeaceSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>


      {/* InnerPeace Main Section Start */}
      <Box mt={5}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h5" className="founder-title mainHeading green-title">
            <i> I Am Peacekeeper  </i> Institute
            </Typography>
            <Typography variant="h5"
          fontWeight="bold"
          gutterBottom
          className="subHeading weathText">
            KNOWLEDGE IS WEALTH
            </Typography>
          </Grid>
        </Grid>
      </Box>

      
        <div className="pilotProgrammeinfo">
          <Typography>
            This November 2025 📅 we commence our Pilot Programme.
          </Typography>

          <Typography>
            The first full course is complimentary for everyone ✅.
          </Typography>

          <Typography>

            It’s your opportunity to experience our transformative learning journey at no cost before the regular fee of US $21 🎯 applies in the next term.
          </Typography>

          <Typography>
            On successful completion and assessment, you will receive a Certificate from the I Am Peacekeeper Institute 🛡️.
          </Typography>

          <Typography>
            Please connect with our trainers by email for guidance and enrolment 🤝.
          </Typography>

          <Typography>
            Each course runs Monday to Friday on the dates below, with Zoom access provided for all sessions.
          </Typography>

        </div>

        {/* zoom meetings card */}

      <Box
        className="mt-50px"
        sx={{
          textAlign: "start",
          borderRadius: 3,
        }}
        mt={5}

      >
        <Box className="core-values-container zoomMeetings">
          <Container style={{ maxWidth: '100%' }}>
            <Grid container spacing={1} justifyContent="center">

              <Grid

                size={{ xs: 12, md: 3, sm: 6 }}
                className={`core-card core-card-cardOne`}
              >
                <Box className="core-card-content">
                  {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                  {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                  {/* <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography> */}

                  <Typography variant="h5" className="founder-title mainHeading green-title">Inner Peace 🧘</Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>Trainer Neha Bilandani 👩‍🏫</Typography>
                  <Typography> <span>Dates: </span>Mon 3 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Fri 14 Nov 2025 📆</Typography>
                  <Typography><span>Time: </span>
                    3:00 – 3:40 PM IST 🕒
                    Pilot schedule for this cohort (Inner Peace):</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 1</span> </Typography>
                  <Typography> Intro and Q&A: Mon 3 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Days 2–8 </span></Typography>
                  <Typography> Main course: Tue 4 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Wed 12 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 9 </span></Typography>
                  <Typography>  Conclusion: Thu 13 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 10 </span> </Typography>
                  <Typography>  Online test & Certificate: Fri 14 Nov 2025</Typography>

                  <div className="zoomBtndiv">
                    <Button
                      variant="contained"
                      className='zoomLinkbtn'
                      onClick={() =>
                        window.open(
                          'https://i-am-peacekeeper.us11.list-manage.com/track/click?u=29b90def99384b76c623a441b&id=449464b01e&e=9a7d6d37b2',
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
                      Zoom Link
                    </Button>
                  </div>

                  <Link
                    sx={{ marginTop: '20px', color: '#beac00' }}
                    href="mailto:neha@i-ampeacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                  >
                    <span>Email: </span> neha@i-ampeacekeeper.com
                  </Link>

                </Box>
              </Grid>

              <Grid

                size={{ xs: 12, md: 3, sm: 6 }}
                className={`core-card core-card-cardTwo`}
              >
                <Box className="core-card-content">
                  {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                  {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                  {/* <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography> */}

                  <Typography variant="h5" className="founder-title mainHeading green-title">Peace Leadership 🧭</Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>Trainer Narges Jalali & Trainer Bidisha Banerjee 👩‍🏫</Typography>
                  <Typography> <span>Dates: </span>Mon 3 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Fri 14 Nov 2025 📆</Typography>
                  <Typography><span>Time: </span>
                    4:00 – 4:40 PM IST 🕓
                    Pilot schedule for this cohort (Peace Leadership):</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 1</span> </Typography>
                  <Typography>Intro and Q&A: Mon 3 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Days 2–8 </span></Typography>
                  <Typography> Main course: Tue 4 Nov – Fri 7 Nov 2025 and Mon 10 Nov – Wed 12 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 9 </span></Typography>
                  <Typography> Conclusion: Thu 13 Nov 2025</Typography>
                  <Typography><span style={{ fontWeight: 'bold' }}>Day 10 </span> </Typography>
                  <Typography>Online test & Certificate: Fri 14 Nov 2025</Typography>

                  <div className="zoomBtndiv">
                    <Button
                      variant="contained"
                      className='zoomLinkbtn'
                      onClick={() =>
                        window.open(
                          'https://i-am-peacekeeper.us11.list-manage.com/track/click?u=29b90def99384b76c623a441b&id=97947c31b4&e=9a7d6d37b2',
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
                      Zoom Link
                    </Button>
                  </div>

                  <Link
                    sx={{ marginTop: '20px', color: '#beac00' }}
                    href="mailto:narges@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                  >
                    <span>Emails: </span> narges@i-am-peacekeeper.com
                  </Link>

                  <Link
                    sx={{ color: '#beac00' }}
                    href="mailto:bidisha@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                  >
                    bidisha@i-am-peacekeeper.com
                  </Link>


                </Box>
              </Grid>

              <Grid

                size={{ xs: 12, md: 3, sm: 6 }}
                className={`core-card core-card-cardOne`}
              >
                <Box className="core-card-content">
                  {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                  {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                  {/* <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography> */}

                  <Typography variant="h5" className="founder-title mainHeading green-title">Women for Peace</Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>Trainer Katalin Enekes</Typography>
                  <Typography> <span>Launch date: </span> Mon 1 Dec 2025</Typography>


                  <Link
                    sx={{ color: '#beac00' }}
                    href="mailto:katalin@i-am-peacekeeper.com"
                    color="inherit"
                    className="trainerEmails"
                  >
                    <span>Email: </span> katalin@i-am-peacekeeper.com
                  </Link>

                </Box>
              </Grid>

            </Grid>
          </Container>
        </Box>
      </Box>

      <div className="sessionText">
        <Typography>
          Each session cultivates calmness, clarity and compassion, helping you practise peace in thought, word and deed 🌱. You’ll learn through live online classes, thoughtful discussion and community-based learning, growing at your pace while standing with a global movement 🌍.
        </Typography>

        <Typography>
          Please register by email with your chosen trainer at the earliest 🔔. We look forward to welcoming you and building a generation of conscious, confident and kind leaders 🔥.
        </Typography>


      </div>

      <div className="bgInsititue">
      <Box>
         <Grid container spacing={2} justifyContent="center" mt={4} mb={4} className="iapmInstitute">
           <Grid size={{ xs: 12, sm: 4, md: 4 }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '120px',
                textAlign: 'center'
              }}
            >
              DATES
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent>
              <Typography
              variant="subtitle1"
              // fontWeight="bold"
              sx=
              {{ textTransform: "uppercase",
                color: "#fff", 
                borderBottom: '1px solid #fff',
                display: 'inline'
              }}
            >
              Nov 3<sup>rd</sup> → 7<sup>th</sup>
            </Typography>

            <Typography
              variant="subtitle1"
              // fontWeight="bold"
              sx={{ textTransform: "uppercase" , color: "#fff",}}
            >
              Nov 10<sup>th</sup> → 14<sup>th</sup>
            </Typography>

            <Typography
              variant="subtitle1"
              // fontWeight="bold"
              sx=
              {{ 
                textTransform: "uppercase" , 
                color: "#fff", 
                textAlign: 'center',
                borderBottom: '1px solid #fff',
                
              }}
            >
              2025
            </Typography>


            <Typography
              variant="subtitle1"
              // fontWeight="bold"
              sx={{ textTransform: "uppercase" , color: "#fff", fontSize: 14 , whiteSpace: 'nowrap'}}
            >
              MONDAY-FRIDAY
            </Typography>

              </CardContent>
             </Card>
           </Grid>
         </Grid>
      </Box>

      <Box>
         <Grid container spacing={0} justifyContent="center" mt={4} mb={4} className="iapmInstitute secondRowcircles">
           <Grid size={{ xs: 12, sm: 4, md: 4 , lg:4 }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Inner <br /> Peace
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  position: 'relative',
                  padding: 0,
                  paddingBottom: 0
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px', // distance between two times
                  }}
                >
                  {/* LEFT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textAlign: 'right',
                      lineHeight: 1.1,
                      marginBottom: '20px'
                    }}
                  >
                    3:00<br />PM
                  </Typography>

                  {/* SLANTED DIVIDER */}
                  <Box
                    sx={{
                      width: '1px',
                      height: '75px',
                      backgroundColor: '#fff',
                      transform: 'rotate(25deg)',
                    }}
                  />

                  {/* RIGHT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      marginTop: '20px',
                      fontSize: '20px',
                      textAlign: 'left',
                      lineHeight: 1.1,
                    }}
                  >
                    3:40<br />PM
                  </Typography>
                </Box>

                {/* IST below */}
                <Typography
                  sx={{
                    marginTop: '10px',
                    borderTop: '1px solid #fff',
                    display: 'inline-block',
                    width: '125px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  IST
                </Typography>
              </CardContent>
             </Card>
             <div class="triangle"></div>

             <div className="trainerDetailsmobile">
                <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Neha Bilandani 
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:neha@i-ampeacekeeper.com"
              color="inherit"
              underline="hover"
            >
              neha@i-ampeacekeeper.com
            </Link>
             </div>
           </Grid>

           <Grid size={{ xs: 12, sm: 4, md: 4, lg:4  }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              PEACE <br/> LEADERSHIP
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  position: 'relative',
                  padding: 0,
                  paddingBottom: 0
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px', // distance between two times
                  }}
                >
                  {/* LEFT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      textAlign: 'right',
                      lineHeight: 1.1,
                      marginBottom: '20px'
                    }}
                  >
                    4:00<br />PM
                  </Typography>

                  {/* SLANTED DIVIDER */}
                  <Box
                    sx={{
                      width: '1px',
                      height: '75px',
                      backgroundColor: '#fff',
                      transform: 'rotate(25deg)',
                    }}
                  />

                  {/* RIGHT TIME */}
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      marginTop: '20px',
                      fontSize: '20px',
                      textAlign: 'left',
                      lineHeight: 1.1,
                    }}
                  >
                    4:40<br />PM
                  </Typography>
                </Box>

                {/* IST below */}
                <Typography
                  sx={{
                    marginTop: '10px',
                    borderTop: '1px solid #fff',
                    display: 'inline-block',
                    width: '125px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  IST
                </Typography>
              </CardContent>
             </Card>
             <div class="triangle"></div>

             <div className="trainerDetailsmobile">
              <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Narges Jalali
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:narges@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              narges@i-am-peacekeeper.com
            </Link>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center',
                marginTop: '10px'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Bidisha Banerjee
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:bidisha@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              bidisha@i-am-peacekeeper.com
            </Link>
             </div>
           </Grid>

           <Grid size={{ xs: 12, sm: 4, md: 4, lg:4  }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              WOMEN <br />FOR PEACE
            </Typography>
             <Card 
             sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height:180,
              width:180 ,
              marginTop: '20px',
              borderRadius: "50%",
              background: 'linear-gradient(90deg, #37c1d6, #3e6a73)'}}>
              <CardContent>
              <Typography
              variant="subtitle1"
              // fontWeight="bold"
              sx=
              {{ textTransform: "uppercase",
                color: "#fff",
                textAlign: 'center'
              }}
            >
                  LAUNCH
                  ON DEC 1st
                  2025
            </Typography>

              </CardContent>
             </Card>
             <div class="triangle"></div>

             <div className="trainerDetailsmobile">
              <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Katalin Enekes
            </Typography>
            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:katalin@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              katalin@i-am-peacekeeper.com
            </Link>
             </div>
           </Grid>

         </Grid>
      </Box>

      <Box>
         <Grid container spacing={0} justifyContent="center" mt={4} mb={4} className="iapmInstitute secondRowcircles mobileTrainersetion">
           <Grid size={{ xs: 12, sm: 4, md: 4 , lg:4 }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '20px',
              borderRight: '1px solid #000',
              height: '190px'
              }} justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Neha Bilandani 
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:neha@i-ampeacekeeper.com"
              color="inherit"
              underline="hover"
            >
              neha@i-ampeacekeeper.com
            </Link>
           </Grid>

           <Grid size={{ xs: 12, sm: 4, md: 4, lg:4  }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '20px',
              borderRight: '1px solid #000',
              height: '190px'
              }} 
              justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Narges Jalali
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:narges@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              narges@i-am-peacekeeper.com
            </Link>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center',
                marginTop: '10px'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Bidisha Banerjee
            </Typography>

            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:bidisha@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              bidisha@i-am-peacekeeper.com
            </Link>
           </Grid>

           <Grid size={{ xs: 12, sm: 4, md: 4, lg:4  }} 
              sx=
              {{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '20px',
              height: '190px'
              }} 
              justifyContent="center">
            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                textTransform: "uppercase", 
                color: "#000",
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Trainer
            </Typography>

            <Typography
              fontWeight="bold"
              sx=
              {{
                fontSize: '18px',
                color: "#000", 
                display: "inline-block",
                width: '200px',
                textAlign: 'center'
              }}
            >
              Katalin Enekes
            </Typography>
            <Link
              sx={{marginTop: '20px' , color: '#beac00' ,  textDecoration: 'underline'}}
              href="mailto:katalin@i-am-peacekeeper.com"
              color="inherit"
              underline="hover"
            >
              katalin@i-am-peacekeeper.com
            </Link>
           </Grid>

         </Grid>
      </Box>
      
      </div>

      {/* <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={5}
        className="core-values-container"
      >
      

        <Container className="core-values-container">
          <Grid container spacing={1} justifyContent="center">
            {coreValues.map((value, index) => (
              <Grid  key={index}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  className={`core-card core-card-${index % 4}`}>
                 <Box className="core-card-content">
      
                    <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography>
                  </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}
     
      {/* course portfolio */}
      <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={5}
        className="TabPaddingContainer"
      >

        {/* Title */}
        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
        Course portfolio
        </Typography>

        <Container className="paddingContainer mt-50px max-width-800px">
          <Grid container spacing={5} justifyContent="center" mb={4}>
            {onlineTest.map(({ text, colorClass }, index) => (
              <Grid size={{ xs: 12, sm: 3, md: 3 }} key={index}>
                <OnlineTestCard text={text} colorClass={colorClass} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
     
      {/* Sub‑programmes  */}
      <Box
        className="mt-50px"
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={5}
        
      >

         {/* Title */}
        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
        Sub Programmes
        </Typography>
        <Box className="core-values-container">
          <Container>
            <Grid container spacing={1} justifyContent="center">
              {coreValues.map((value, index) => (
                <Grid
                  key={index}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  className={`core-card core-card-${index % 4}`}
                >
                  <Box className="core-card-content">
                    {/* <img
                      src={value.image}
                      alt={value.title}
                      className="core-image"
                    /> */}
                    {/* <Typography variant="h6" className="core-title">
                      {value.title}
                    </Typography> */}
                    <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>

      {/* benefits all courses */}

       <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
        }}
        mt={0}
        className="core-values-container"
      >
       {/* Title */}
        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
        Benefits 
        </Typography>
       <Container className="core-values-container">
          <Grid container spacing={1} justifyContent="center">
            {courseBenefits.map((value, index) => (
              <Grid  key={index}
                  size={{ xs: 12, md: 3, sm: 6 }}
                  className={`core-card core-card-${index % 4}`}>
                 <Box className="core-card-content">
      
                    <Typography variant="body2" className="core-description">
                      {value.description}
                    </Typography>
                  </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
     
       {/* benefits all courses */}

       <Box
        sx={{
          textAlign: "center",
          borderRadius: 3,
          marginBottom:'70px'
        }}
        mt={0}
        className="TabPaddingContainer"

      >
       {/* Title */}
        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
          className="subHeading"
        >
        The Journey Continues
        </Typography>
       <Container className="paddingContainer mt-50px" mb={5}>
          <Grid container spacing={5} justifyContent="center" mb={4}>
            {circleCourses.map(({ text, colorClass }, index) => (
              <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                <ConclusionCard text={text} colorClass={colorClass} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      {/* Blue Button */}
      {/* <Box className="d-flex-align-center-justify-center" mt={5}>
        <Grid container spacing={0}>
          <Grid size={12}>
            <Button variant="contained" className="blueButton">
              (400 Minutes Total)
            </Button>
          </Grid>
        </Grid>
      </Box> */}

      {/* last contact section */}

      {/* <Box
        sx={{ textAlign: "center", py: 4 }}
        className="contactQueryMainSection"
      >
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          gutterBottom
          className="contactQueryTitle"
        >
          For queries and support, please contact:
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <Typography variant="body1">Ms. Neha Bilandani</Typography>
          <Typography variant="body1">
            <a
              href="mailto:neha@i-am-peacekeeper.com"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              neha@i-am-peacekeeper.com
            </a>
          </Typography>
          <Typography variant="body1">+91 99306 80975</Typography>
        </Stack>
      </Box> */}
    </>
  );
};

export default Courses;
